import { useEffect, useCallback } from 'react';
import * as L from "leaflet";
import Json from '../map.json';


const MapMoveEvents = ({ map, setData, searchMarker, towerFilters, viewbox }) => {

  const onMoveEnd = useCallback(() => {
    let bounds = map.getBounds();
    let bData = Json.features.filter(feature => {
      let ll = L.latLng(feature.geometry.coordinates[1], feature.geometry.coordinates[0]);
      return bounds.contains(ll);
    });

    bData.forEach(feature => {
      feature.properties.isFiltered = false;
      //Distance Filter
      if (towerFilters.distance && feature.properties.POIDistance &&
        Number(feature.properties.POIDistance) > Number(towerFilters.distance)) {
        feature.properties.isFiltered = true;
      }
      //Height Filter
      if (towerFilters.height.length > 0 &&
        (Number(feature.properties['Overall Tower Height']) < Number(towerFilters.height[0]) ||
          Number(feature.properties['Overall Tower Height']) > Number(towerFilters.height[1]))) {
        feature.properties.isFiltered = true;
      }
      //Compute Distance
      if (searchMarker) {
        let sll = L.latLng(searchMarker);
        let ll = L.latLng(feature.geometry.coordinates[1], feature.geometry.coordinates[0]);
        feature.properties.POIDistance = (sll.distanceTo(ll) * 0.000621371).toFixed(2);
      }
    });
    //Sort by distance if marker exists.
    if (searchMarker) {
      bData.sort((a, b) => {
        if (a.properties.isFiltered === b.properties.isFiltered) return Number(a.properties.POIDistance) - Number(b.properties.POIDistance);
        return a.properties.isFiltered ? 1 : -1;
      });
    }else{
      bData.sort((a, b) => {
        if (a.properties.isFiltered === b.properties.isFiltered) return a.properties['Assest Nick Name'].localeCompare(b.properties['Assest Nick Name'])
        return a.properties.isFiltered ? 1 : -1;
      });
    }

    setData(bData);
  }, [map, setData, searchMarker, towerFilters])

  const onFilterDistanceSet = useCallback(() => {
    if (towerFilters.distance && searchMarker) {
      const dist = Number(towerFilters.distance) * Number(1609.34) * 2
      const LL = L.latLng(searchMarker[0], searchMarker[1]);
      map.flyToBounds(LL.toBounds(dist));
    }
  }, [map, towerFilters, searchMarker])

  useEffect(() => {
    onFilterDistanceSet();
  }, [towerFilters.distance, onFilterDistanceSet])

  useEffect(() => {
    onMoveEnd();
  }, [towerFilters, onMoveEnd])

  useEffect(() => {
    map.on('moveend', onMoveEnd)
    return () => {
      map.off('moveend', onMoveEnd)
    }
  }, [map, onMoveEnd])

  const zoomToBounds = useCallback(() => {
    map.flyToBounds([[viewbox[1], viewbox[0]], [viewbox[3],viewbox[2]]]);
  }, [map, viewbox])

  useEffect(() => {
    zoomToBounds();
  }, [zoomToBounds])

  return null;
}

export default MapMoveEvents;